'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = 'M195 37.4c17.5-24.8 51.4-32.9 78.4-17.7l5.2 3.3c23.2 16.4 31.8 46.9 20.4 72.9l-2.7 5.5-32.9 58.6 160.7 0 5.7 .3C458 163.2 480 187 480 216l-.5 7.2c-1.7 12.8-7.7 24.2-16.5 32.8 10.4 10.2 17 24.3 17 40l-.5 7.3c-1.9 14.3-9.2 26.8-19.7 35.6 2.7 6.5 4.2 13.6 4.2 21.1l-.2 4.8c-1.8 20.9-15 38.4-33.4 46.4 1 4.1 1.6 8.4 1.6 12.8l-.3 5.7c-2.7 26.4-23.6 47.3-50 50l-5.7 .3-107.7 0c-14.2 0-28.4-2.4-41.8-7l-.2-.1-5.4-2-.2-.1-28.3-11.3c-28.1-11.2-50.5-31.7-64.5-57l0 37.5c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40L0 200c0-22.1 17.9-40 40-40l48 0 4.1 .2c10.6 1.1 20 6.3 26.5 14.1 1.5-3.8 3.2-7.4 5.2-11l67.9-120.7 3.3-5.2zM40 176c-13.3 0-24 10.7-24 24l0 240c0 13.2 10.7 24 24 24l48 0c13.3 0 24-10.8 24-24l0-240c0-12.4-9.4-22.6-21.5-23.9l-2.5-.1-48 0zM265.6 33.7c-19.9-11.2-44.7-5.3-57.5 13l-2.4 3.8-67.9 120.7c-5.5 9.9-8.8 20.9-9.6 32.1l0 0-.2 5.4 0 131.7 .3 9.1c3.3 42.2 30.3 79.3 70.1 95.2l28.3 11.3 0 0 5.1 1.9 8.9 2.7c9 2.3 18.3 3.5 27.7 3.5l107.7 0 4.1-.2c18.8-1.9 33.8-16.9 35.7-35.7l.2-4.1c0-5.2-1-10.2-2.9-14.8-.8-2.1-.7-4.5 .3-6.5 1-2 2.9-3.6 5.1-4.2 16-4.3 27.9-18.2 29.4-35.1l.2-3.4c0-7.1-1.9-13.8-5.2-19.7-2.1-3.7-.9-8.4 2.7-10.7 9.8-6.2 16.6-16.5 18.2-28.4l.3-5.2c0-13.9-7.1-26.2-17.9-33.4-2.2-1.5-3.6-4-3.6-6.7s1.3-5.2 3.6-6.7c10.8-7.2 17.9-19.4 17.9-33.3l-.2-4.1c-1.9-18.8-16.9-33.8-35.7-35.7l-4.1-.2-174.3 0c-2.8 0-5.5-1.5-6.9-4s-1.4-5.5-.1-7.9l39.7-70.5 2-4c8.3-19.1 2-41.5-15-53.5l-3.8-2.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;